<template>
  <div class="default_layout">
    <app-header/>
    <router-view class="content"/>
  </div>
</template>

<script>
import AppHeader from '@/components/header'

export default {
  components: {
    AppHeader
  }
}
</script>

<style>

</style>
